import { Component, OnInit,ViewChild,TemplateRef, ElementRef } from '@angular/core';
import { IndividualReportServices } from './individual-report.service';
import {MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import {MatPaginator, MatTableDataSource,MatSort,MatDialog,MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
declare const $: any;
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-individual-report',
  templateUrl: './individual-report.component.html',
  styleUrls: ['./individual-report.component.css']
})
export class IndividualReportComponent implements OnInit {
   
  organization_id:any;
  publish_report_list:any;
  specific_student_report_card_data:any;
  performance_set_assessment_id:any;
  spinner_div:any;
  no_report_card_data:boolean=true;  
  report_card_data:any;
  player_id:any;
  default_scores:any;
  legends:any;
  input_assessment_name:any;
  start_date:any; 
  end_date:any; 
  report_type:string;
  report_name:any;

  msg:any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  setAutoHide: boolean = true;
  autoHide: number = 3000;
  actionButtonLabel: string = 'Close';
  action: boolean = true;
 
  sub:any;
  // auth_key:any;
  // session_id:any;
  // device_id:any;
  org_id:any;
  academy_center_id:any;
  org_logo:any;
  report_publish_id:any;  
  academy_logo:any;
  reportname:any;
  organization_name:any;
  academy_center_name:any;
  performance_set_details:any;

  doc_src: any;
  image_doc_flag: any = false;
  pdf_doc_flag: any = false;

  report_card_color:any;
  card_color:any;
  text_color:any;
  report_header:any;
  bottom_border:any;
  box_shadow:any;
  ranking: any;
  player_count: any;
  percentile: any;
  authorization: any;
  performance_set_criteria_setting_id: any;
  activity_report: any;
  default_report_score: any=[];
  preference_center_name: any;
  success_msg: string;
  aws_cover_page_image: string;
  aws_signature_image: string;
  player_image: string;
  report_list: any;
  report_list_flag: boolean;
  assessment_id: any;
  activity_id: any;
  center_name: any;
  nsa_report_flag: any;
  constructor(private IR_services:IndividualReportServices,public snackBar:MatSnackBar,
    private route:ActivatedRoute,public dialog: MatDialog,private _sanitizer: DomSanitizer) {
    this.activity_report='';
       this.sub = this.route.queryParams.subscribe(params => {        
          //this.auth_key = params['auth_key'];
          //this.device_id = params['device_id'];
          //this.session_id = params['session_id'];
          this.player_id = params['player_id'];
          this.organization_id = params['org_id'];
          this.academy_center_id = params['academy_center_id'];
          this.performance_set_assessment_id=params['performance_set_assessment_id'];
          this.authorization=params['Authorization'];
          this.performance_set_criteria_setting_id=params['performance_set_criteria_setting_id'];
          this.activity_report=params['activity_report'];
          this.report_publish_id=params['report_publish_id'];
          this.activity_id = params['activity_id'];
          this.center_name = params['center_name'];
          this.nsa_report_flag =params['nsa_assessment_card'];
         //this.assessment_id = params['assessment_id'];
       });
      // localStorage.setItem("auth_key", this.auth_key);
      // localStorage.setItem("session_id", this.session_id);
      // localStorage.setItem("device_id", this.device_id);
         localStorage.setItem('access_token', this.authorization);
      }
   
     ngOnInit() {
      
        if(this.organization_id=='2115')
       {
         this.report_card_color='#080824fc'; // dark blue
         this.card_color='#15154fcc';  // blue
         this.text_color='#dddddd';  //white
         this.report_header='#ffd700'; //gold
         this.bottom_border='#080824fc';
         this.box_shadow='0px 0px 0px ';
       }
       else
       {
         this.report_card_color='#ffffff'; // white
         this.card_color='#efefef';
         this.text_color='#555';
         this.bottom_border='#eee';
         this.box_shadow='1px 1px 6px #c7c7c7'; 
   
       }
       this.openReportCardList(this.player_id);
     }
     openReportCardList(player_id: any,)
     {        
      this.player_id=player_id; 
     //this.IR_services.getReportList(this.player_id,this.organization_id,this.assessment_id).subscribe(
       this.IR_services.getReportList(this.player_id,this.organization_id,this.performance_set_assessment_id,this.activity_id).subscribe(
       response => {      
         if (response != '') 
         { 
           
           this.report_list=response['data']['assessment_activity_report']; 
           if(this.report_list.length>1)
           {
             this.report_list_flag=true;
           } 
           else
           {
             this.report_list_flag=false;
             this.report_list.forEach(element => {            
              this.getReportCard(element['performance_set_criteria_setting']);
             });
   
           }
          
         }
         else 
         {        
           this.success_msg="Published report details not found";
           this.snackBarDisplay();     
         }
       },); 
     }
    getReportCard(selected_test)
    {      
      var performance_set_criteria_setting_id=[];
       selected_test.forEach(element => {
         performance_set_criteria_setting_id.push(element.performance_set_criteria_setting_id);
       });
       this.spinner_div="block";
       this.IR_services.getPlayerReport(this.organization_id,performance_set_criteria_setting_id,this.performance_set_assessment_id,this.player_id,this.academy_center_id).subscribe(
       response1 => {
         if(response1 != ''){
   
         
         if (response1['data']['report_card']!=false) 
         {  
           var response= response1['data']['report_card'];     
           if(response['legend']!=undefined || response['legend']!=null )
           {
             this.legends=response['legend'];             
           }            
           this.input_assessment_name=response['input_assessment_name'];
           this.start_date=response['start_date'];
           this.end_date=response['end_date'];  
           this.academy_logo ='data:image/png;base64,'+response['logo_path_base_64'];
           // this.getBase64ImageFromURL(response['logo_path']).subscribe(base64data => {          
           //   this.academy_logo = 'data:image/jpg;base64,' + base64data;              
           // });   
           this.report_type=response['report_type'];  
           this.reportname=response['input_assessment_name'];
           this.report_name=response['report_name'];              
           this.organization_name=response['organization_name'];
           this.spinner_div="none";        
           this.specific_student_report_card_data=response['player']; 
           this.player_image = 'data:image/jpg;base64,'+this.specific_student_report_card_data[0]['player_image_base_64'];
           // this.getBase64ImageFromURL(this.specific_student_report_card_data[0]['player_image']).subscribe(base64data => {          
           //   this.player_image = 'data:image/jpg;base64,' + base64data;              
           // }); 
           this.ranking=this.specific_student_report_card_data[0]['ranking'];
           this.player_count=this.specific_student_report_card_data[0]['player_count'];
           this.percentile=this.specific_student_report_card_data[0]['percentile'];
           this.academy_center_name=this.specific_student_report_card_data[0]['academy_center_name'];         
           this.performance_set_details=this.specific_student_report_card_data[0]['performance_set_details']; 
           if(this.specific_student_report_card_data[0]['add_cover_page_flag']==1){
             this.aws_cover_page_image = 'data:image/png;base64,'+this.specific_student_report_card_data[0]['aws_cover_page_image_base_64'];
             // this.getBase64ImageFromURL(this.specific_student_report_card_data[0]['aws_cover_page_image']).subscribe(base64data => {          
             //   this.aws_cover_page_image = 'data:image/jpg;base64,' + base64data;              
             // }); 
           }
           if(this.specific_student_report_card_data[0]['add_signature_flag']==1){
             this.aws_signature_image = 'data:image/png;base64,'+this.specific_student_report_card_data[0]['signatures'][0]['aws_signature_image_base_64']
             // this.getBase64ImageFromURL(this.specific_student_report_card_data[0]['signatures'][0]['aws_signature_image']).subscribe(base64data => {          
             //   this.aws_signature_image = 'data:image/jpg;base64,' + base64data;              
             // }); 
           }
          
           this.default_report_score=[];           
             if(this.report_type=='default')
             {
             this.specific_student_report_card_data[0]['performance_parameters'].forEach((element,j) => {
               this.default_scores=[]; 
             element['scores'].forEach(element1 => 
             {   
               if( element1.score_type_name=='Numeric')
               {
                 if(element1.better_score!='-' && element1.score!='-' && element1.better_score!='' && element1.score!='')
                 {
                   this.default_scores.push({'better_score':(parseFloat(element1.better_score)),    
                   'min_score':(parseFloat(element1.min)),
                   'max_score':(parseFloat(element1.max)),       
                   'performance_parameter_name':element.performance_parameter_name,
                   'score':(parseFloat(element1.score)),            
                   'desc':element.performance_parameter_description,
                   'comments':element1.comments,
                   'score_unit':element1.score_unit,
                   'score_label':element1.score_label,
                   'performance_set_id':element.performance_set_id,
                   'score_type_name':element1.score_type_name,
                   'performance_area_name':element.performance_area_name,
                   'batch_avg_score':element1.batch_avg_score});
                 }
                 
               }
               if( element1.score_type_name=='Rating')
               {
                 this.default_scores.push({'better_score':(parseFloat(element1.better_score)),           
                 'performance_parameter_name':element.performance_parameter_name,
                 'score':(parseFloat(element1.score)),            
                 'desc':element.performance_parameter_description,
                 'comments':element1.comments,
                 'score_unit':element1.score_unit,
                 'score_label':element1.score_label,
                 'rating_details':element1.rating_details,
                 'performance_set_id':element.performance_set_id,
                 'score_type_name':element1.score_type_name,
                 'performance_area_name':element.performance_area_name,
                 'batch_avg_score':element1.batch_avg_score,
                 'better_score_grade':element1.better_score_grade,
                 'batch_avg_score_grade':element1.batch_avg_score_grade});
               }
               
               if(element1.score_type_name=='Dropdown' || element1.score_type_name=='Text' || element1.score_type_name=='Document/Image')
               {
                 
                 this.default_scores.push({         
                 'performance_parameter_name':element.performance_parameter_name,
                 'score': this.videoURLConverter(element1),            
                 'desc':element.performance_parameter_description,
                 'comments':element1.comments,
                 'score_unit':element1.score_unit,
                 'score_label':element1.score_label,
                 'performance_set_id':element.performance_set_id,
                 'score_type_name':element1.score_type_name,
                 'performance_area_name':element.performance_area_name,
                 'file_type':element1.file_type
                 });
                 
               }
               if(element1.score_type_name=='Stopwatch')
               {
                 this.default_scores.push({         
                 'performance_parameter_name':element.performance_parameter_name,
                 'score':parseFloat(element1.score),            
                 'desc':element.performance_parameter_description,
                 'comments':element1.comments,
                 'score_unit':element1.score_unit,
                 'score_label':element1.score_label,
                 'performance_set_id':element.performance_set_id,
                 'score_type_name':element1.score_type_name,
                 'performance_area_name':element.performance_area_name,
                 'score_mm_ss_ms':element1.score_mm_ss_ms,
                 'better_score':parseFloat(element1.better_score),
                 'better_score_mm_ss_ms':element1.better_score_mm_ss_ms,
                 'batch_avg_score':element1.batch_avg_score,
                 'batch_avg_score_mm_ss_ms':element1.batch_avg_score_mm_ss_ms});
               }
             });     
             this.default_report_score.push(this.default_scores);        
           });
         } 
   
               if(this.report_type=='by_criteria')
               {
               this.specific_student_report_card_data[0]['performance_parameters'].forEach((element,j) => {            
                 this.default_scores=[]; 
                element['scores'].forEach(element1 => {
                  if(element1.score_type_name=='Numeric')
                 {
                     this.default_scores.push({                  
                      
                       'performance_parameter_name':element.performance_parameter_name,                    
                       'parameter_score_compare_criteria_key':element1.parameter_score_compare_criteria_key,
                       'min_score':(parseFloat(element1.min)),
                       'max_score':(parseFloat(element1.max)),
                       'min_score1':(parseFloat(element1.min_score)),
                       'max_score1':(parseFloat(element1.max_score)),
                       'score':(parseFloat(element1.score)),
                       'batch_highest_score':(parseFloat(element1.batch_highest_score)),
                       'batch_lowest_score':(parseFloat(element1.batch_lowest_score)),
                       'avg_score':(parseFloat(element1.avg_score)),
                       'benchmark_score':(parseFloat(element1.benchmark_score)),
                       'less_than_min_score_color':element1.less_than_min_score_color,
                       'less_than_min_score_label':element1.less_than_min_score_label,
                       'in_between_min_and_max_score_color':element1.in_between_min_and_max_score_color,
                       'in_between_min_and_max_score_label':element1.in_between_min_and_max_score_label,
                       'greater_than_max_score_color':element1.greater_than_max_score_color,
                       'greater_than_max_score_label':element1.greater_than_max_score_label,
                       'color':element1.color,
                       'desc':element.performance_parameter_description,
                       'comments':element1.comments,
                       'is_allow_show_comment':element1.is_allow_show_comment,
                       'is_allow_show_desc':element1.is_allow_show_desc,
                       'score_unit':element1.score_unit,
                       'label':element1.label,
                       'lowest_in_batch_score_label':element1.lowest_in_batch_score_label,
                       'highest_in_batch_score_label':element1.highest_in_batch_score_label,
                       'closer_to_average_in_batch_score_label':element1.closer_to_average_in_batch_score_label,
                       'score_label':element1.score_label,
                       'score_type_name':element1.score_type_name,
                       'performance_area_name':element.performance_area_name,
                       'batch_avg_score':element1.batch_avg_score,
                       'is_display_parameter':element.is_display_parameter});
                   
   
                 } 
                 if(element1.score_type_name=='Rating')
                 {
                    this.default_scores.push({
                       
                       'performance_parameter_name':element.performance_parameter_name,                    
                       'parameter_score_compare_criteria_key':element1.parameter_score_compare_criteria_key,
                       'min_score':(parseFloat(element1.min)),
                       'max_score':(parseFloat(element1.max)),
                       'score':(parseFloat(element1.score)),
                       'benchmark_score':(parseFloat(element1.benchmark_score)),
                       'color':element1.color,
                       'desc':element.performance_parameter_description,
                       'comments':element1.comments,
                       'is_allow_show_comment':element1.is_allow_show_comment,
                       'is_allow_show_desc':element1.is_allow_show_desc,
                       'score_unit':element1.score_unit,
                       'score_label':element1.score_label,
                       'rating_details':element1.rating_details,
                       'score_type_name':element1.score_type_name,
                       'performance_area_name':element.performance_area_name,
                       'batch_avg_score':element1.batch_avg_score,
                       'better_score_grade':element1.better_score_grade,
                       'batch_avg_score_grade':element1.batch_avg_score_grade,
                       'is_display_parameter':element.is_display_parameter});
                 }             
                  if(element1.score_type_name=='Dropdown' || element1.score_type_name=='Text' || element1.score_type_name=='Document/Image')
               {
                 this.default_scores.push({
                       
                       'performance_parameter_name':element.performance_parameter_name,                    
                       'parameter_score_compare_criteria_key':element1.parameter_score_compare_criteria_key,
                       'min_score':element1.min_score,
                       'max_score':element1.max_score,
                       'score': this.videoURLConverter(element1), 
                       'batch_highest_score':element1.batch_highest_score,
                       'batch_lowest_score':element1.batch_lowest_score,
                       'avg_score':element1.avg_score,
                       'benchmark_score':element1.benchmark_score,
                       'less_than_min_score_color':element1.less_than_min_score_color,
                       'less_than_min_score_label':element1.less_than_min_score_label,
                       'in_between_min_and_max_score_color':element1.in_between_min_and_max_score_color,
                       'in_between_min_and_max_score_label':element1.in_between_min_and_max_score_label,
                       'greater_than_max_score_color':element1.greater_than_max_score_color,
                       'greater_than_max_score_label':element1.greater_than_max_score_label,
                       'color':element1.color,
                       'desc':element.performance_parameter_description,
                       'comments':element1.comments,
                       'is_allow_show_comment':element1.is_allow_show_comment,
                       'is_allow_show_desc':element1.is_allow_show_desc,
                       'score_unit':element1.score_unit,
                       'score_label':element1.score_label,
                       'score_type_name':element1.score_type_name,
                       'performance_area_name':element.performance_area_name,
                       'file_type':element1.file_type,
                       'is_display_parameter':element.is_display_parameter});
                 } 
                 
                 if(element1.score_type_name=='Stopwatch')
                 {
                     this.default_scores.push({                  
                      
                       'performance_parameter_name':element.performance_parameter_name,                    
                       'parameter_score_compare_criteria_key':element1.parameter_score_compare_criteria_key,
                       'score':(parseFloat(element1.score)),
                       'score_label':element1.score_label,
                       'score_unit':element1.score_unit,
                       'score_mm_ss_ms':element1.score_mm_ss_ms,
                       'desc':element.performance_parameter_description,
                       'comments':element1.comments,
                       'is_allow_show_comment':element1.is_allow_show_comment,
                       'is_allow_show_desc':element1.is_allow_show_desc,
                       'color':element1.color,
                       'label':element1.label,
                       'benchmark_score':(parseFloat(element1.benchmark_score)),
                       'benchmark_score_mm_ss_ms':element1.benchmark_score_mm_ss_ms,
                       'min_score':(parseFloat(element1.min)),
                       'max_score':(parseFloat(element1.max)),
                       'min_score1':(parseFloat(element1.min_score)),
                       'max_score1':(parseFloat(element1.max_score)),
                       'min_score_mm_ss_ms':element1.min_score_mm_ss_ms,
                       'max_score_mm_ss_ms':element1.max_score_mm_ss_ms,
                       'less_than_min_score_color':element1.less_than_min_score_color,
                       'less_than_min_score_label':element1.less_than_min_score_label,
                       'in_between_min_and_max_score_color':element1.in_between_min_and_max_score_color,
                       'in_between_min_and_max_score_label':element1.in_between_min_and_max_score_label,
                       'greater_than_max_score_color':element1.greater_than_max_score_color,
                       'greater_than_max_score_label':element1.greater_than_max_score_label,
                       'optimum':element1.optimum,                    
                       'batch_highest_score':(parseFloat(element1.batch_highest_score)),
                       'highest_in_batch_score_label':element1.highest_in_batch_score_label,
                       'batch_highest_score_mm_ss_ms':element1.batch_highest_score_mm_ss_ms,
                       'batch_lowest_score':(parseFloat(element1.batch_lowest_score)),
                       'lowest_in_batch_score_label':element1.lowest_in_batch_score_label,
                       'batch_lowest_score_mm_ss_ms':element1.batch_lowest_score_mm_ss_ms,
   
                       'avg_score':(parseFloat(element1.avg_score)),
                       'avg_score_mm_ss_ms':element1.avg_score_mm_ss_ms,                    
                       'closer_to_average_in_batch_score_label':element1.closer_to_average_in_batch_score_label,
                       
                       'score_type_name':element1.score_type_name,
                       'performance_area_name':element.performance_area_name,
                       'batch_avg_score':element1.batch_avg_score,
                       'batch_avg_score_mm_ss_ms':element1.batch_avg_score_mm_ss_ms,
                       'is_display_parameter':element.is_display_parameter});                
   
                 }      
               });             
               this.default_report_score.push(this.default_scores);       
             });
           }         
            
         }
         else 
         {    
           this.spinner_div="none";         
           this.success_msg="Report card details not found";      
           this.snackBarDisplay();   
         }
       } else 
       {    
         this.spinner_div="none";         
         this.success_msg="Report card details not found";      
         this.snackBarDisplay();   
       }
       },    
     );
   }
   
   videoURLConverter(score){
     
     if(score.file_type=='VIDEO'){
       let pattern = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
       var match =score.score.match(pattern); 
       if(match!=null)
       {              
       
           return this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/'+match[7]);
         
       }
       else{
    
           return this._sanitizer.bypassSecurityTrustResourceUrl( this.parseVimeo(score.score));       
        
       }
     }
     else{
       return score.score;
     } 
   }
   
   parseVimeo(url) {
       
       const re = /\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i;
       const matches = re.exec(url);
       return matches && "https://player.vimeo.com/video/"+matches[1];
     }
    snackBarDisplay()
       {
         const config = new MatSnackBarConfig();
         config.verticalPosition = this.verticalPosition;
         config.horizontalPosition = this.horizontalPosition;
         config.duration = this.setAutoHide ? this.autoHide : 0;
         this.snackBar.open(this.success_msg,this.action ? this.actionButtonLabel : undefined,config);
       } 
   
    @ViewChild('specific_report_card') specific_report_card:ElementRef;
   
}